import React from 'react';
import { FaCircleInfo } from 'react-icons/fa6';

const Required = () => (
    <div
      className="flex items-center mt-4 mb-[-10px]"
    >
      <span className="text-red-600">* Required field</span>&nbsp;&nbsp;
      <FaCircleInfo className="mr-2 mt-[2px] scale-90 text-gray-400" />
    </div>
  );

export default Required;
